/**
 * Persists the selected subscription (plan or custom payload) when a new user
 * is sent to Register. After OTP, Checkout reads this so the user lands with
 * the plan they originally selected.
 */
import AsyncStorage from '@react-native-async-storage/async-storage';

const SELECTED_SUBSCRIPTION_KEY = 'selectedSubscription';

/**
 * Synchronous mirror so OTP / `navigation.reset(Checkout)` can read the plan before
 * AsyncStorage `setItem` flushes (race with `useRequireVerified` + `useLayoutEffect` order).
 */
let memory_selected_subscription: unknown | null = null;

export function peekSelectedSubscription(): unknown | null {
  return memory_selected_subscription;
}

export async function getSelectedSubscription(): Promise<unknown | null> {
  if (memory_selected_subscription != null) {
    return memory_selected_subscription;
  }
  try {
    const raw = await AsyncStorage.getItem(SELECTED_SUBSCRIPTION_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw) as unknown;
    memory_selected_subscription = parsed;
    return parsed;
  } catch {
    return null;
  }
}

export async function setSelectedSubscription(payload: unknown): Promise<void> {
  memory_selected_subscription = payload;
  try {
    await AsyncStorage.setItem(SELECTED_SUBSCRIPTION_KEY, JSON.stringify(payload));
  } catch {
    // ignore
  }
}

export async function clearSelectedSubscription(): Promise<void> {
  memory_selected_subscription = null;
  try {
    await AsyncStorage.removeItem(SELECTED_SUBSCRIPTION_KEY);
  } catch {
    // ignore
  }
}
